module.exports = __webpack_public_path__ + "static/media/logoPost.a26a27db.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/wellnet/media/logoPost.png
// module id = 852
// module chunks = 0